"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";
import { queryClient } from "@/config/react-query";
import { usePatientClaim } from "@/hooks/patient-claim/use-patient-claim";
import { SelfSchedulePatient } from "@/types/self-schedule";
import { MfaAuth, MfaAuthPanel, MfaAuthPanelProps, MfaAuthProps } from "./mfa-auth";
interface MfaGateProps extends MfaAuthPanelProps {
  surface: MfaAuthProps["surface"];
  children: ReactNode;
  onPatientVerified?: (patient: SelfSchedulePatient) => void;
}
function MfaGateInner(t0) {
  const $ = _c(13);
  let children;
  let onPatientVerified;
  let panelProps;
  let surface;
  if ($[0] !== t0) {
    ({
      surface,
      children,
      onPatientVerified,
      ...panelProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = onPatientVerified;
    $[3] = panelProps;
    $[4] = surface;
  } else {
    children = $[1];
    onPatientVerified = $[2];
    panelProps = $[3];
    surface = $[4];
  }
  const {
    claimedPatient: patient
  } = usePatientClaim();
  if (!patient) {
    let t1;
    if ($[5] !== panelProps) {
      t1 = <MfaAuthPanel {...panelProps} />;
      $[5] = panelProps;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== onPatientVerified || $[8] !== surface || $[9] !== t1) {
      t2 = <MfaAuth surface={surface} onPatientVerified={onPatientVerified}>{t1}</MfaAuth>;
      $[7] = onPatientVerified;
      $[8] = surface;
      $[9] = t1;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    return t2;
  }
  let t1;
  if ($[11] !== children) {
    t1 = <>{children}</>;
    $[11] = children;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
}
export function MfaGate(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <QueryClientProvider client={queryClient}><MfaGateInner {...props} /></QueryClientProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}